function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from "../../../styles/theme";
import BreadcrumbItem from "./BreadcrumbItem";
var CRUMB_NAME_DEFAULT = 'breadcrumbName';
var CRUMB_NAME_ALT = 'name';
var styles = StyleSheet.create({
  Breadcrumb: {
    display: 'flex',
    alignItems: 'center'
  }
});

function getBreadcrumbName(route, params) {
  var routePartial = route[CRUMB_NAME_DEFAULT] || route[CRUMB_NAME_ALT];

  if (!routePartial) {
    return '';
  }

  var paramsKeys = Object.keys(params).join('|');
  var name = routePartial.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
    return params[key] || replacement;
  });
  return name;
}

function defaultItemRender(_ref) {
  var route = _ref.route,
      params = _ref.params,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes,
      _ref$paths = _ref.paths,
      paths = _ref$paths === void 0 ? [] : _ref$paths;
  var isLastItem = routes.indexOf(route) === routes.length - 1;
  var name = getBreadcrumbName(route, params);
  return isLastItem ? React.createElement("span", null, name) : React.createElement("a", {
    href: "/".concat(paths.join('/'))
  }, name, " ");
}

export default function Breadcrumb(_ref2) {
  var _ref2$htmlAttributes = _ref2.htmlAttributes,
      htmlAttributes = _ref2$htmlAttributes === void 0 ? {} : _ref2$htmlAttributes,
      _ref2$rootClassName = _ref2.rootClassName,
      rootClassName = _ref2$rootClassName === void 0 ? '' : _ref2$rootClassName,
      _ref2$separatorClassN = _ref2.separatorClassName,
      separatorClassName = _ref2$separatorClassN === void 0 ? '' : _ref2$separatorClassN,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? {} : _ref2$style,
      children = _ref2.children,
      _ref2$itemRender = _ref2.itemRender,
      itemRender = _ref2$itemRender === void 0 ? defaultItemRender : _ref2$itemRender,
      _ref2$params = _ref2.params,
      params = _ref2$params === void 0 ? {} : _ref2$params,
      routes = _ref2.routes,
      _ref2$separator = _ref2.separator,
      separator = _ref2$separator === void 0 ? '/' : _ref2$separator;
  var crumbs;

  if (routes && Array.isArray(routes) && routes.length > 0) {
    var paths = [];
    crumbs = routes.map(function (routeAlt, index) {
      var route = routeAlt;
      route.path = route.path || '';
      var path = route.path.replace(/^\//, '');
      Object.keys(params).forEach(function (key) {
        path = path.replace(":".concat(key), params[key]);
      });

      if (path) {
        paths.push(path);
      } // $FlowFixMe


      var hideSeparator = index === routes.length - 1; // $FlowFixMe

      var itemRenderContent = itemRender({
        route: route,
        params: params,
        routes: routes,
        paths: paths
      });
      return React.createElement(BreadcrumbItem, {
        separator: separator,
        key: route[CRUMB_NAME_DEFAULT] || route[CRUMB_NAME_ALT] || path,
        hideSeparator: hideSeparator,
        separatorClassName: separatorClassName,
        isCurrentPage: hideSeparator
      }, itemRenderContent);
    });
  } else {
    crumbs = React.Children.map(children, function (elem, index) {
      if (!elem) {
        return elem;
      }

      var isLastItem = index === React.Children.count(children) - 1; // $FlowFixMe

      return React.cloneElement(elem, _objectSpread({
        separatorClassName: separatorClassName,
        separator: separator,
        key: index,
        hideSeparator: isLastItem
      }, isLastItem ? {
        isCurrentPage: true
      } : {}));
    });
  }

  return React.createElement("div", _extends({
    role: "navigation",
    "aria-label": "Breadcrumb"
  }, htmlAttributes, css(rootClassName, styles.Breadcrumb), {
    style: style
  }), crumbs);
}
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.defaultProps = {
  htmlAttributes: {},
  rootClassName: '',
  style: {},
  params: {},
  separator: '/'
};
Breadcrumb.propTypes = {
  htmlAttributes: PropTypes.object,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  routes: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    breadcrumbName: PropTypes.string,
    name: PropTypes.string
  }).isRequired),
  params: PropTypes.object,
  separator: PropTypes.node,
  children: PropTypes.node,
  itemRender: PropTypes.func
};